import { api } from '@cma/app'
import {
  CreatePlatformClientContentMutation,
  CreatePlatformClientContentMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useCreatePlatformClientContent() {
  const queryClient = useQueryClient()

  return useMutation<
    CreatePlatformClientContentMutation,
    Error,
    CreatePlatformClientContentMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation CreatePlatformClientContent(
          $input: PlatformClientContentInput!
        ) {
          createPlatformClientContent(input: $input) {
            platformClientContents {
              accountId
              id
              folderId
              displayName
              platformClientContentContentType
              platformClientContentUrl
              thumbnail
              ownerType
              ownerId
              createdAt
              updatedAt
            }
          }
        }
      `
      return api<
        CreatePlatformClientContentMutation,
        CreatePlatformClientContentMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess({ createPlatformClientContent }) {
        const accountId =
          createPlatformClientContent?.platformClientContents?.[0]?.accountId
        await queryClient.invalidateQueries([
          'platformContent',
          {
            id: accountId || ''
          }
        ])
      }
    }
  )
}
